import useAuth from "./useAuth";
import {EIdUserType, IAuthData} from "../types";
import {useEffect, useState} from "react";


const useCanShowDashboardLink = () => {
	const { auth } = useAuth();

	const getCanShowCart = (auth?: IAuthData) => {
		return auth?.userData?.IdUserType === EIdUserType.SuperAdmin || auth?.userData?.IdUserType === EIdUserType.Admin
			|| auth?.userData?.IdUserType === EIdUserType.Seller || auth?.userData?.IdUserType === EIdUserType.Operator
	}

	const [canShowDashboardLink, setCanShowDashboardLink] = useState<boolean>(getCanShowCart(auth));

	useEffect( () => {
		const newCan = getCanShowCart(auth);
		//console.log("Can show cart", newCan, auth)

		setCanShowDashboardLink(newCan);

	}, [auth]);

	return canShowDashboardLink;
};

export default useCanShowDashboardLink;